module.exports = {"532325101":"栋川镇","532325102":"光禄镇","532325103":"前场镇","532325104":"弥兴镇","532325105":"太平镇","532325106":"官屯镇","532325201":"适中乡","532325202":"左门乡","532325204":"大河口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532325.json
// module id = 2618
// module chunks = 0